import { useGeneratePermitRenewals as useGeneratePermitRenewalsBase } from "hooks/useGeneratePermitRenewals";

import { DOCUMENTS } from "../index";

type UseGeneratePermitRenewalsProps = {
  onSuccess?: () => void;
};

/** Documents-grid wrapper that refetches the documents query after generation. */
export function useGeneratePermitRenewals(props?: UseGeneratePermitRenewalsProps) {
  return useGeneratePermitRenewalsBase({
    onSuccess: props?.onSuccess,
    refetchQueries: [DOCUMENTS],
  });
}
